/**
 * @namespace helpers
 */

export default callback => {
    /**
     * @method scrollStop
     * @description Run a callback function after scrolling has stopped
     *
     * @todo DW [2020/01/13]: Create polyfill for `window.scrollTo` so this script can be tested
     *
     * @memberof helpers
     * @author Chris Ferdinandi, MIT License, https://gomakethings.com (c) 2017
     *
     * @param  {function} callback function to run after scrolling
     *
     * @example
     * scrollStop(() => {
     *    console.log('Finishing scrolling');
     *
     *    this.setState({
     *        scrolling: false
     *    });
     * });
     */

    /**
     * @todo DW [2020/02/11]: complete tests
     * @todo DW [2020/02/11]: complete docs
     */

    // Make sure a valid callback was provided
    if (!callback || typeof callback !== 'function') return;

    // Setup scrolling variable
    let isScrolling;

    // Listen for scroll events
    window.addEventListener(
        'scroll',
        () => {
            // Clear our timeout throughout the scroll
            window.clearTimeout(isScrolling);

            // Set a timeout to run after scrolling ends
            isScrolling = setTimeout(function() {
                // Run the callback
                callback();
            }, 66);
        },
        false
    );
};
